<script lang="ts">
  import { highlightSegments } from '../lib/searchHighlight';

  interface Props {
    text: string;
    tokens: string[];
    variant: 'title' | 'meta';
  }

  let { text, tokens, variant }: Props = $props();
</script>

<span class={variant}
  >{#each highlightSegments(text, tokens) as segment}{#if segment.highlighted}<mark
        >{segment.text}</mark
      >{:else}{segment.text}{/if}{/each}</span
>

<style>
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .title {
    color: #111827;
    font-size: 0.9rem;
    font-weight: 600;
  }

  .meta {
    color: #6b7280;
    font-size: 0.75rem;
  }

  mark {
    padding: 0 1px;
    color: inherit;
    background: #fde68a;
    border-radius: 2px;
  }
</style>
